import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './processflow.css';
import ContentPasteSearchIcon from '@mui/icons-material/ContentPasteSearch';
import HomeIcon from '@mui/icons-material/Home';
import PermPhoneMsgIcon from '@mui/icons-material/PermPhoneMsg';
import FamilyRestroomIcon from '@mui/icons-material/FamilyRestroom';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import InfoIcon from '@mui/icons-material/Info';
import Callbackpopup from '../callbackpopup/Callbackpopup';
import Productdetails from '../callbackpopup/Productdetails';

const Processflow = () => {
    const navigate = useNavigate();
    const [isPopupOpen, setPopupOpen] = useState(false);
    const [isProductPopupOpen, setProductPopupOpen] = useState(false);
    const [cardItemValue, setCardItemValue] = useState('');


    const openProductPopup = (cardItemName) => {
        console.log('Opening product popup for:', cardItemName);
        setProductPopupOpen(true);
        setCardItemValue(cardItemName);
        document.body.style.overflow = 'hidden';
    };

    const closePopup = () => {
        setPopupOpen(false);
        document.body.style.overflow = 'auto';
    };

    const closeProductPopup = () => {
        setProductPopupOpen(false);
        document.body.style.overflow = 'auto';
    };

    const processSteps = [
        {
            id: 1,
            icon: HomeIcon,
            title: "Confirm Readiness for Possession",
            description: "Ensure your home is complete and ready for occupancy. Verify all construction is finished, utilities are connected, and quality standards are met!",
            color: "#3F51B5",
            gradient: "linear-gradient(135deg, #3F51B5 0%, #5C6BC0 100%)"
        },
        {
            id: 2,
            icon: PermPhoneMsgIcon,
            title: "Schedule a Professional Home Inspection",
            description: "Hire a professional home inspection service provider to thoroughly examine your home and identify any potential issues!",
            color: "#F47436",
            gradient: "linear-gradient(135deg, #F47436 0%, #FF8A65 100%)"
        },
        {
            id: 3,
            icon: ContentPasteSearchIcon,
            title: "Receive a Comprehensive Snag Report",
            description: "Get a detailed snag report of any defects found. Share it with your developer to have all issues addressed promptly!",
            color: "#2A4F73",
            gradient: "linear-gradient(135deg, #2A4F73 0%, #3A5F7A 100%)"
        },
        {
            id: 4,
            icon: FamilyRestroomIcon,
            title: "Move Into a Defect-Free Home",
            description: "Ensure the developer repairs all defects. Once resolved, take possession and enjoy a worry-free, happy home!",
            color: "#4CAF50",
            gradient: "linear-gradient(135deg, #4CAF50 0%, #66BB6A 100%)"
        }
    ];

    return (
        <div className="process-flow-section">
            <div className="process-flow-container">
                {/* Header Section */}
                <div className="process-flow-header">
                    <div className="process-flow-badge">
                        <CheckCircleIcon className="badge-icon" />
                        <span>Step-by-Step Guide</span>
                    </div>
                    <h2 className="process-flow-title">
             A Perfect Home Possession After Perfect Home Inspection
             </h2>
                    <p className="process-flow-description">
             Follow these essential steps to ensure your new home is flawless and ready for a worry-free move-in!
             </p>
                </div>

                {/* Process Steps */}
                <div className="process-steps-container">
                    {processSteps.map((step, index) => {
                        const IconComponent = step.icon;
                        return (
                            <div key={step.id} className="process-step-card" data-step={step.id}>
                                <div className="step-number">{step.id}</div>
                                
                                <div className="step-icon-container" style={{ background: step.gradient }}>
                                    <IconComponent className="step-icon" />
                                </div>
                                
                                <div className="step-content">
                                    <h3 className="step-title">{step.title}</h3>
                                    <p className="step-description">{step.description}</p>
                                </div>

                                {/* Arrow connector (except for last step) */}
                                {index < processSteps.length - 1 && (
                                    <div className="step-connector">
                                        <ArrowForwardIcon className="connector-arrow" />
                                    </div>
                                )}
                            </div>
                        );
                    })}
                </div>

                {/* Integrated CTA & Offers Section */}
                <div id="process-flow-offers" className="process-flow-cta-offers">
                    <div className="cta-header">
                        <h3>Ready to Start Your Home Inspection Journey?</h3>
                        <p>Choose from our comprehensive home inspection packages and ensure a defect-free, stress-free possession experience!</p>
                    </div>
                    
                    <div className="offers-grid">
                        <div className="offer-card featured">
                            <div className="offer-badge">Most Popular</div>
                            <div className="offer-content">
                                <div className="offer-icon">
                                    <HomeIcon className="offer-icon-svg" />
                                </div>
                                <h4 className="offer-title">Comprehensive Inspection</h4>
                                {/* <p className="offer-description">A detailed end-to-end property assessment ensuring RERA carpet area compliance, safety, and quality across all structural, utility, and finishing aspects.</p> */}
                                <div className="offer-features">
                                    <div className="feature-item"><b>✓ RERA Carpet Area Verification</b></div>
                                    <div className="feature-item">✓ Thermal Inspection</div>
                                    <div className="feature-item">✓ Electrical Inspection</div>
                                    <div className="feature-item">✓ Plumbing Inspection</div>
                                    <div className="feature-item">✓ Walls & Ceilings Inspection</div>
                                    <div className="feature-item">✓ Flooring Inspection</div>
                                    <div className="feature-item">✓ Doors & Windows Inspection</div>
                                    <div className="feature-item">✓ Paint & Finishing Inspection</div>
                                    <div className="feature-item">✓ Counter Top & Sink Inspection</div>
                                    <div className="feature-item">✓ Fireline Inspection</div>
                                    <div className="feature-item">✓ Safety Features Inspection</div>
                                </div>
                                <div className="offer-buttons">
                                    <button 
                                        className="offer-button primary" 
                                        onClick={() => navigate('/book-inspection')}
                                    >
                                        <span>Book Complete Inspection</span>
                                        <ArrowForwardIcon className="button-icon" />
                                    </button>
                                    <button 
                                        className="offer-button info" 
                                        onClick={() => openProductPopup("Comprehensive Home Inspection")}
                                    >
                                        <InfoIcon className="button-icon" />
                                        <span>Info</span>
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div className="offer-card">
                            <div className="offer-content">
                                <div className="offer-icon">
                                    <ContentPasteSearchIcon className="offer-icon-svg" />
                                </div>
                                <h4 className="offer-title">Complete Home Inspection</h4>
                                {/* <p className="offer-description">A thorough inspection of the home covering all essential quality and safety aspects.</p> */}
                                <div className="offer-features">
                                    <div className="feature-item">✓ Thermal Inspection</div>
                                    <div className="feature-item">✓ Electrical Inspection</div>
                                    <div className="feature-item">✓ Plumbing Inspection</div>
                                    <div className="feature-item">✓ Walls & Ceilings Inspection</div>
                                    <div className="feature-item">✓ Flooring Inspection</div>
                                    <div className="feature-item">✓ Doors & Windows Inspection</div>
                                    <div className="feature-item">✓ Paint & Finishing Inspection</div>
                                    <div className="feature-item">✓ Counter Top & Sink Inspection</div>
                                    <div className="feature-item">✓ Fireline Inspection</div>
                                    <div className="feature-item">✓ Safety Features Inspection</div>
                                </div>
                                <div className="offer-buttons">
                                    <button 
                                        className="offer-button secondary" 
                                        onClick={() => navigate('/book-inspection')}
                                    >
                                        <span>Book Comprehensive</span>
                                        <ArrowForwardIcon className="button-icon" />
                                    </button>
                                    <button 
                                        className="offer-button info" 
                                        onClick={() => openProductPopup("Complete Home Inspection")}
                                    >
                                        <InfoIcon className="button-icon" />
                                        <span>Info</span>
                                    </button>
                                </div>
                            </div>
                        </div>

                        {/* <div className="offer-card">
                            <div className="offer-content">
                                <div className="offer-icon">
                                    <PermPhoneMsgIcon className="offer-icon-svg" />
                                </div>
                                <h4 className="offer-title">Quick Consultation</h4>
                                <p className="offer-description">Expert consultation and guidance for your home inspection needs</p>
                                <div className="offer-features">
                                    <div className="feature-item">✓ 30-min Consultation</div>
                                    <div className="feature-item">✓ Expert Advice</div>
                                    <div className="feature-item">✓ Inspection Checklist</div>
                                    <div className="feature-item">✓ Follow-up Support</div>
                                </div>
                                <div className="offer-pricing">
                                    <span className="current-price">Free</span>
                                </div>
                                <div className="offer-buttons">
                                    <button 
                                        className="offer-button secondary" 
                                        onClick={() => openPopup("Request Callback")}
                                    >
                                        <span>Get Free Consultation</span>
                                        <ArrowForwardIcon className="button-icon" />
                                    </button>
                                    <button 
                                        className="offer-button info" 
                                        onClick={() => openProductPopup("Quick Consultation")}
                                    >
                                        <InfoIcon className="button-icon" />
                                        <span>Info</span>
                                    </button>
                                </div>
                            </div>
                        </div> */}
                    </div>

                    <div className="cta-footer">
                        <p className="guarantee-text">
                            <CheckCircleIcon className="guarantee-icon" />
                            100% Satisfaction Guarantee • Professional Certified Inspectors • Detailed Reports
                        </p>
                    </div>
                </div>
            </div>
            
            {/* Popup Components */}
            {isPopupOpen && <Callbackpopup onClose={closePopup} cardItem={cardItemValue}/>}
            {isProductPopupOpen && <Productdetails onClose={closeProductPopup} cardItem={cardItemValue}/>}
                    </div>
    );
};

export default Processflow;